import request from '@/utils/request'
import { praseStrEmpty } from "@/utils/ruoyi";

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/system/user/' + praseStrEmpty(userId),
    method: 'get'
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data
  })
}
// 修改过期提醒
export function editExpired(data) {
  return request({
    url: '/system/user/editExpired',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete'
  })
}
// // 删除个人账号
// export function delPerson(userId) {
//   return request({
//     url: '/system/user/' + userId,
//     method: 'delete'
//   })
// }
// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get'
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data
  })
}
// 用户附加车辆
export function addAnother(data) {
  return request({
    url: '/car/additional/insertBatch',
    method: 'post',
    data: data,
    timeout: 60000,
  })
}
// 查询附加车辆列表
export function addAnotherList(data) {
  return request({
    url: '/car/additional/getAddInfo',
    method: 'get',
    params: data
  })
}
//下发查岗问题
export function sendQuestion(data) {
  return request({
    url: '/websocket/websocket/sendMessage',
    method: 'post',
    data: data
  })
}
// 查询用户信息
export function authSafe(data) {
  return request({
    url: '/auth/safe',
    method: 'get',
    params: data
  })
}
// 机构下的所有机构的用户都会给设置个默认的基础权限的功能
export function resetMenuIds(data) {
  return request({
    url: '/system/user/resetMenuIds',
    method: 'get',
    params: data
  })
}
